module.exports = __webpack_public_path__ + "img/SC.f9d39e9d.svg";